import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'eflyn-product-catalog';
  constructor() {
    console.log((window as any).CATALOG_DATA);
  }
}
